{
  "en": {
    "worksheet": {
      "autoSave": {
        "saved": "Changes saved",
        "saveFailed": "Changes could not be saved",
        "sessionExpired": "Your session has expired. Please log in again to save changes.",
        "draftRestoreFailed": "Draft could not be restored"
      },
      "submitFailed": "Submission failed. Please try again.",
      "aiGenerator": {
        "breadcrumbs": {
          "course": "Course",
          "focus": "Define focus",
          "knowledge": "Knowledge",
          "tasks": "Select tasks",
          "topic": "Topic",
          "verify": "Verify worksheet"
        },
        "buttons": {
          "createProposals": "Create proposals",
          "createWorksheet": "Create worksheet",
          "creating": "Processing …",
          "generateLearningObjectives": "Generate objectives with AI",
          "generateNewProposals": "Generate alternative proposals",
          "generateTextBasis": "Generate text with AI",
          "regenerateLearningObjectives": "Regenerate objectives with AI",
          "regenerateTextBasis": "Regenerate text with AI",
          "retry": "Retry",
          "showTextBasis": "Show text basis at top of worksheet"
        },
        "course": {
          "grade": "Grade level",
          "language": "Language",
          "school": "School type",
          "subject": "Subject"
        },
        "descriptions": {
          "fillInTheBlank": "Fill in the gaps using the following words:<br/><strong>{hints}</strong>"
        },
        "errors": {
          "generationFailed": "The worksheet could not be created. Please try again."
        },
        "headers": {
          "createTitle": "Create worksheet with AI assistance",
          "kinds": {
            "fill_in_the_blank_text": "Fill in the blank text selection",
            "multiple_choice": "Multiple choice task selection",
            "single_choice": "Single choice task selection",
            "text": "Short introduction selection",
            "text_assignment": "Text assignment selection",
            "text_assignment_1": "Text assignment (requirement range I) selection",
            "text_assignment_2": "Text assignment (requirement range II) selection",
            "text_assignment_3": "Text assignment (requirement range III) selection"
          },
          "sampleSolution": "Sample solution:",
          "title": "Create a worksheet with AI"
        },
        "hints": {
          "creatingLearningObjectives": "AI is creating learning objectives",
          "creatingTextBasis": "AI is creating text basis",
          "error": "There was an error. Unfortunately, we could not create any suggestions for you.",
          "learningObjectives": "Specific learning objectives help define the context of the tasks more precisely and thereby ensure more suitable suggestions.",
          "progressMessage": "AI is creating tasks",
          "prompt": "Hint: The more specific you are, the more specific the suggested tasks will be.",
          "textBasis": "The text basis serves to sharpen the focus of the worksheet."
        },
        "knowledge": {
          "subtitle": "Optionally, you can add a source from which the AI extracts the background knowledge for the worksheet."
        },
        "labels": {
          "gradeLevel": "Select grade level",
          "languageLevel": "Select language level (CEFR)",
          "learningObjectiveHeading": "Learning objective for this worksheet",
          "learningObjectives": "Learning objectives (optional)",
          "schoolType": "Select school type",
          "subjectType": "Select subject",
          "textBasis": "What content should the worksheet refer to?",
          "topic": "Topic or focus area",
          "topicHeading": "Topic or question for this worksheet",
          "worksheetLanguage": "Select language"
        },
        "placeholders": {
          "learningObjectiveHeading": "Which competencies should be developed? (e.g., analysis and evaluation of the starting conditions of the Weimar Republic).",
          "learningObjectives": "Enter learning objectives...",
          "prompt": "Name the topic your tasks are supposed to be based on. For example: Main causes and events of the industrial revolution.",
          "textBasis": "Enter a text basis...",
          "topicHeading": "What main topics should the worksheet cover? (e.g., \"The Beginning of the Weimar Republic\")"
        }
      },
      "aiPromptModal2": {
        "headers": {
          "title": "Generate text exercise with AI"
        },
        "labels": {
          "prompt": "Requirements"
        },
        "placeholders": {
          "prompt": "Describe the focus of the task and, if necessary, provide a key question or learning goal."
        },
        "description": "What do you want to create?"
      },
      "aiGeneration": {
        "createWithAi": "Create with AI",
        "dropdownLabel": "AI generation options",
        "pending": "AI is creating content...",
        "menu": {
          "newVariant": "Vary content",
          "harder": "Harder task",
          "easier": "Easier task",
          "addHelp": "Add guidance",
          "simpleLanguage": "Simple language",
          "custom": "Custom request"
        },
        "prompts": {
          "newBlock": "Create a suitable {blockType} block as the next meaningful step in this worksheet.",
          "newVariant": "Create a variant of this block: Change the context, numbers, or wording so that the task cannot be solved from memory of the original. Keep the learning objective and difficulty the same.",
          "harder": "Make this block more challenging by requiring more thinking—not more work.",
          "easier": "Make this block easier: Simplify the language and structure and remove unnecessary information. Keep the learning objective and technical terms—explain technical terms instead of replacing them.",
          "addHelp": "Add guidance, intermediate steps, or examples without giving away the solution.",
          "simpleLanguage": "Rewrite this block in simple language. Keep technical terms from the learning objective and block, and explain them where needed.",
          "guidance": {
            "fillInTheBlank": "For fill-in-the-blank: fill the description and cloze text; vary the gaps to match the request."
          }
        }
      },
      "aiContext": {
        "title": "AI Focus for this Worksheet",
        "button": "AI Settings",
        "description": "Here you can specify for whom you are creating the worksheet. This information helps the AI suggest suitable tasks for you. In each task block, you can have the AI suggest content.",
        "sections": {
          "schoolDetails": {
            "title": "School Key Data"
          },
          "backgroundKnowledge": {
            "title": "Background Knowledge"
          }
        },
        "labels": {
          "subjectTypes": "Subject",
          "schoolTypes": "School Type",
          "gradeLevels": "Grade Level",
          "locale": "Language",
          "addBackgroundKnowledge": "Add Background Knowledge",
          "backgroundKnowledge": "Background Knowledge for the AI"
        },
        "descriptions": {
          "addBackgroundKnowledge": "Add background knowledge from various sources, such as file uploads, websites, YouTube videos, audio files, or videos."
        },
        "actions": {
          "removeSource": "Remove Source"
        },
        "hints": {
          "hasSources": "Sources available"
        },
        "sourceKinds": {
          "text": "Text",
          "file": "File",
          "pdf": "PDF",
          "image": "Image",
          "website": "Website",
          "youtube": "YouTube",
          "audio": "Audio",
          "video": "Video"
        },
        "flash": {
          "saveFailed": "AI settings could not be saved"
        },
        "sourcePicker": {
          "title": "Add background knowledge",
          "subtitle": "Select a source and the AI will extract the text as background knowledge for the worksheet."
        },
        "recent": {
          "empty": "No sources yet. Add background knowledge first.",
          "error": "The most recently used sources could not be loaded."
        },
        "placeholders": {
          "backgroundKnowledge": "Add information and highlight content aspects that are particularly important to you..."
        }
      },
      "blockTypes": {
        "Divider": "Divider",
        "File": "File",
        "FillInTheBlankText": "Fill in the Blank",
        "H5p": "H5P",
        "Hint": "Hint",
        "Image": "Image",
        "MultipleChoice": "Multiple Choice",
        "SingleChoice": "Single Choice",
        "Spacer": "Space",
        "PageBreak": "Page Break",
        "StaticText": "Rich Text",
        "Text": "Text Response",
        "Upload": "File Submission",
        "Video": "Video",
        "ToTeachExercise": "to teach Exercise"
      },
      "blockTypesV2": {
        "Upload": "File Submission",
        "ToTeachExercise": "to teach Exercise"
      },
      "inserterHints": {
        "toTeachExercise": "New: Use your to teach content in your fobizz worksheets.",
        "pageBreak": "New: Focus the view with page breaks."
      },
      "navigation": {
        "headline": "Your Progress",
        "previousPage": "Back",
        "nextPage": "Next Page"
      },
      "buttons": {
        "addOption": "Add option",
        "submit": "Submit",
        "confirmDelete": "Yes, delete",
        "duplicate": "Duplicate",
        "generate": "Generate",
        "deleteResponse": "Delete submission",
        "moveDown": "Move down",
        "moveUp": "Move up",
        "remove": "Delete",
        "removeOption": "Remove option"
      },
      "elements": "Elements",
      "addNewBlock": "Add new block",
      "multimedia": "Multimedia",
      "layout": "Layout",
      "feedback": {
        "form": {
          "actions": {
            "reset": {
              "label": "Delete feedback",
              "message": {
                "success": "Feedback deleted"
              }
            },
            "submit": {
              "label": "Save feedback",
              "message": {
                "error": "Feedback could not be saved",
                "success": "Feedback has been saved"
              }
            }
          },
          "fieldset": {
            "text": {
              "label": "Write personal note"
            }
          },
          "headline": "Add individual feedback"
        },
        "public": {
          "headline": "Feedback to your worksheet from {name}"
        },
        "shareLinkBox": "Share your feedback to this response",
        "status": {
          "hasFeedback": "Feedback added"
        }
      },
      "fillInTheBlankDefault": {
        "answerOption": "This is an example of a gapped text with a {'{'}  gap {'}'}. There can be {'{'} many/multiple/various {'}'} possible answers provided. In this case, in the first sentence, 'gap' would be the correct answer. In the second sentence, both 'many,' 'multiple,' and 'various' would be correct.",
        "description": "Your description text with instructions for editing (not the gapped text). You can also offer suggested solutions for the assignment, for example, like this: 'Fill in the gapped text with the following terms: <i><mark>Word 1</mark></i>, <i><mark>Word 2</mark></i>...'"
      },
      "fillInTheBlankEditor": {
        "descriptionLabel": "Description text",
        "descriptionHint": "Use the description text for editing instructions. You can also offer suggested solutions for the assignment. For example {italic}",
        "descriptionHintItalic": "\"Fill in the blanks with the following terms: Germany, Federal State, Republic,...\"",
        "clozeLabel": "Fill-in-the-blank text",
        "clozeHint": "\"Example of a fill-in-the-blank text with a <strong>{'{'} gap {'}'}</strong>. Multiple <strong>{'{'} many/multiple {'}'}</strong> answers can be defined.\" In this case, 'gap' would be the correct answer and in the second sentence both 'many' and 'multiple' would be correct.",
        "insertGap": "Insert gap"
      },
      "flash": {
        "addOptionSuccess": "Option added",
        "createBlockSuccess": "Block added",
        "createSolutionSuccess": "Solution added",
        "deleteBlockSuccess": "Block deleted",
        "duplicateBlockSuccess": "Block duplicated",
        "deleteOptionSuccess": "Option deleted",
        "deleteSolutionSuccess": "Solution deleted",
        "moveBlockSuccess": "Block moved",
        "updateBlockSuccess": "Block updated",
        "updateClozeTestSuccess": "Fill in the blank text updated",
        "updateOptionSuccess": "Option updated",
        "updateSolutionSuccess": "Solution updated",
        "updateWorksheetSuccess": "Worksheet updated",
        "updateWorksheetError": "Worksheet could not be updated"
      },
      "headings": {
        "saveShareLink": "Remember the link to this page in case you want to access your results later."
      },
      "hints": {
        "Divider": "Use this horizontal divider to structure the worksheet visually.",
        "File": "Upload extra work material here (e.g. a text file, an image or a PDF) that you want your students to download or view. Tip: Use the Upload task block to make your students submit their own version of the material within the same worksheet.",
        "FillInTheBlankText": "Write a text or individual questions with predefined answers to be filled in. Use the symbols {'{'} and {'}'} to mark a gap in the text and enclose the correct word or words. For multiple correct answer options, use the symbol / as a divider. For example, you could write: \"The student has to fill in {'{'}a/the{'}'} gap.\" In this case, both answers 'a' and 'the' are correct. All answers are automatically evaluated.",
        "H5p": "Embed interactive H5P content into your worksheet. Upload an .h5p file to create interactive exercises, quizzes, and learning games.",
        "Hint": "Give your students extra information with this visual hint.",
        "Image": "Add an image from the image search or upload your own image to enrich your worksheet with visual content.",
        "MultipleChoice": "Ask a question and provide possible answers. Mark the correct answers by selecting the circles next to them. The evaluation indicates which tasks were easy and where your students still need the most repetition.",
        "SingleChoice": "Ask a question and provide possible answers. Mark the correct answer by selecting the circle next to it. The evaluation indicates which tasks were easy and where your students still need the most repetition.",
        "Spacer": "Add some white space to structure the worksheet visually.",
        "PageBreak": "Use page breaks to split the worksheet into multiple pages you can navigate between.",
        "StaticText": "Use the text element to provide explanations and additional information for your students. Note that they cannot hand in anything here. Use the text response for this.",
        "Text": "Write a work assignment for which your students can digitally submit a response in a text field.",
        "Upload": "Create an assignment for your students to upload a file (e.g., a text file, an image, or a PDF). All submitted files can later easily be reviewed and evaluated in one place.",
        "ToTeachExercise": "Search for interactive exercises from to teach and embed them directly into your worksheet.",
        "Video": "Embed YouTube or Vimeo videos by entering the URL here (for example: https://vimeo.com/469669139).",
        "answered": "answered",
        "dragNDrop": "Hint: Upload your file directly via drag & drop",
        "dropFileHere": "Drop file here or select file",
        "dropH5pFileHere": "Drop H5P file here or",
        "uploadH5pFilePrompt": "Drop H5P file here or select file",
        "elements": "Include explanations and content for your students and structure your worksheet.",
        "h5pContentStatus": "Status: {status}",
        "h5pFileRequirement": "Only .h5p files are allowed",
        "h5pProcessing": "H5P content is being processed, please wait...",
        "h5pProcessingFailed": "H5P processing failed. Please try again.",
        "h5pProcessingStalled": "Processing this H5P content is taking unusually long. Please try again later or contact support.",
        "h5pReloadHint": "Content not displaying? Reload page",
        "h5pFileUploadSuccess": "H5P file uploaded successfully.",
        "h5pPreviewHint": "You can try the module in the preview.",
        "toTeachExerciseImportSuccess": "to teach exercise imported successfully.",
        "maxOptionsReached": "Maximum of {max} options can be added.",
        "name": "Insert your pseudonym or name abbreviation here.",
        "noDescriptionOrCloze": "No description or fill in the blank text entered",
        "emptyBlock": "<strong>This block is empty.</strong> It will not appear in the preview or in the student view.",
        "noDescriptionOrOptions": "No description or options entered",
        "fileUploadSuccess": "File uploaded successfully.",
        "noFile": "No file uploaded",
        "noH5pContent": "No H5P content uploaded",
        "h5pNotPrintable": "This interactive content cannot be printed.",
        "noHint": "No hint entered",
        "noImage": "No image uploaded",
        "noInput": "No input",
        "selectFile": "Select file",
        "noSolution": "No solution entered",
        "noText": "No text entered",
        "noVideo": "No video embedded",
        "processingH5pFile": "Processing H5P file...",
        "questions": "Create assignments with fields that your students can fill in.",
        "submitSuccessful": "Thank you! You have successfully submitted your worksheet.",
        "searchToTeachExercises": "Search to teach exercises...",
        "processingToTeachExercise": "Importing and processing to teach exercise...",
        "noToTeachExercisesFound": "No exercises found",
        "noToTeachExercise": "No to teach exercise selected",
        "toTeachSsoNotLinked": "Your account is not yet linked with to teach. Connect your account to use your to teach content on fobizz. <a href=\"https://to-teach.ai/auth/fobizz\" target=\"_blank\" rel=\"noopener noreferrer\">Go to to teach</a>",
        "videoError": "The given URL is invalid. Please insert a valid address or remove it.",
        "videoExample": "Example: https://vimeo.com/469669139"
      },
      "labels": {
        "clozeGap": "Gap {current} of {total}",
        "confirmDeleteBlock": "Delete block?",
        "confirmDeleteBlockText": "Warning: If you remove this block, all associated submissions will also be deleted.",
        "confirmDeleteResponse": "Are you sure you want to delete this submission?",
        "confirmDeleteResponseText": "Should the response really be deleted?",
        "confirmSubmitIncompleteResponse": "You have not filled in all the questions yet. Do you still want to submit your answer?",
        "confirmSubmitResponse": "Do you want to submit the worksheet now?",
        "confirmSubmitResponseTitle": "Submit worksheet?",
        "confirmSubmitKeepEditing": "Keep editing",
        "confirmSubmitAnyway": "Yes, submit",
        "draft": "Draft | Drafts",
        "response": "Submission | Submissions",
        "responseStatus": {
          "draft": "In Progress",
          "submitted": "Completed"
        },
        "respondingAs": "You are answering this worksheet as {pseudonym}",
        "responsesTab": "Drafts and Submissions",
        "worksheet": "Worksheet"
      },
      "links": {
        "shareResponse": "Copy student link",
        "showResponseSolutionToggle": "Show sample solution",
        "taskNo": "Task #{ index }"
      },
      "placeholders": {
        "FillInTheBlankText": "Enter fill in the blank text",
        "answerInput": "Insert answer",
        "clickToEdit": "Click to edit",
        "description": "Enter description",
        "hint": "Enter hint",
        "imageCaption": "Insert image caption",
        "optionInput": "Insert option",
        "videoCaption": "Insert video caption",
        "videoUrl": "Insert video url"
      },
      "promptAttributes": {
        "derivedLanguageSkillLevel": {
          "1": "in very simple language and easily understandable phrasings and vocabulary for children between 5 and 7 years old",
          "2": "in simple language and easily understandable phrasings and vocabulary for children between 7 and 10 years old",
          "3": "in clear and understandable phrasings and vocabulary for children between 10 and 13 years old",
          "4": "in understandable language and clear phrasings and vocabulary for teenagers between 13 and 16 years old",
          "5": "in appropriate language and with subject-specific terms, phrasings and vocabulary for young adults aged 17 or older"
        },
        "regeneration": {
          "prompt": "\n\nIMPORTANT: Create clearly different new proposals. Do not repeat any of the following earlier proposals or just rephrase them slightly.{strategyInstruction}\nPrevious proposals:\n{previousProposals}",
          "strategyInstruction": "\nThis time, deliberately use this alternative approach: {strategy}",
          "strategies": {
            "everydayContext": "Use an everyday context with concrete examples.",
            "playfulFormat": "Use a playful or puzzle-like formulation with a different sentence structure.",
            "analyticalPerspective": "Use a factual, analytical perspective with different content emphases.",
            "creativeScenario": "Use a creative story or a new scenario as the starting point.",
            "compareCauseEffect": "Use a comparison or cause-and-effect focus instead of the previous approach."
          }
        },
        "systemPrompt": "You are an experienced {subjectType} teacher at a {schoolType} and are very familiar with the curriculum for this target group. Your content is optimized in content and language for students of the age group {gradeLevel} and formulated {derivedLanguageSkillLevel}. You MUST answer in JSON only. You MUST use the provided schema definition and the examples. Do not return any additional fields or text.",
        "userPrompt": {
          "fill_in_the_blank_text": "Always refer to the context of the base text marked by triple quotation marks. Base text: \"\"\"{textBasis}\"\"\". Create 3 versions of a short fill-in-the-blank text with 5 blanks each by rephrasing the contents of the base text. Each of the 5 blanks should be presented by curly brackets and contain the solution. ",
          "learning_objectives": "You're an educational expert for the subject {subjectType} specialized in designing learning objectives in accordance to Bloom's Taxonomy. Your mission: Formulate learning objectives for a lesson unit for grade level {gradeLevel} on the lesson topic '{prompt}'. Differentiate the learning objectives so that they cover levels 1-2, 3-4 and 5 of the taxonomy and formulate 2 learning objectives per level. Output simple main sentences in JSON format according to the following structure example: ",
          "single_choice": "Always refer to the context of the base text marked by triple quotation marks in all your answers. Base text: \"\"\"{textBasis}\"\"\". Write a quiz with 3 questions that have 3 answers each, including only one correct solution. The text must be formatted in JSON format and structured according to this example: ",
          "text_assignment": "Always refer to the base text marked by triple quotation marks and always formulate the text assignment in the given language. Base text: \"\"\"{textBasis}\"\"\". Create 3 detailed text assignments, each with a sample solution consisting of about {count} words, that relates to the content of the base text. The assignment correspond to the requirement range {name} with the definition: '{description}'. Do not write assignments with the question words Who?, What?, When?, Where?, Why? or closed questions. Instead, operationalize the assignments and choose one of the following or similar operators for each of the tasks in the imperative: {operators}. The text must be formatted in JSON format and structured according to this example: ",
          "text_basis": "Write an informational text as a basis for a worksheet, which vividly presents and explains content relevant to the school curriculum in the subject {subjectType}. The text should only contain information and contribute to achieving the following learning objectives: {learningObjectives}. The topic of the text is '{prompt}'. Only output the requested content and refrain from introductory and concluding comments to frame the answer. The text should consist of a single paragraph of 100 to 500 words and should not contain any special characters, control characters, or line breaks. The text must be formatted in JSON format and be structured according to this example: "
        }
      },
      "questions": "Questions",
      "solution": {
        "actions": {
          "add": "Add sample solution",
          "delete": "Delete sample solution",
          "showResponseSolution": "Show all solutions after submission"
        },
        "hints": {
          "showResponseSolution": "Your students will see the sample solutions after submitting their answers."
        },
        "title": "Sample solution",
        "types": {
          "text": {
            "placeholder": "Enter sample solution..."
          }
        }
      },
      "words": {
        "of": "of"
      }
    }
  }
}
